export default __webpack_public_path__ + "static/media/senobi_jump_thumb.5ceb76d5.png";